import CustomizationStyle from "../../../../content/sdk/web/2.x.x/_common/customizationStyle.mdx";
import Form from "../../../../content/sdk/web/2.x.x/_common/form.mdx";
import SubmitButton from "../../../../content/sdk/web/2.x.x/_common/submitButton.mdx";
import ProcessingIndicator from "../../../../content/sdk/web/2.x.x/_common/processingIndicator.mdx";
import ErrorMessage from "../../../../content/sdk/web/2.x.x/_common/errorMessage.mdx";
import SuccessScreen from "../../../../content/sdk/web/2.x.x/primer/_showUniversalCheckout/successScreen.mdx";
import PaymentMethodsOptions from "../../../../content/sdk/web/2.x.x/_common/paymentMethodsOptions.mdx";
import ClientSessionCachingEnabled from "../../../../content/sdk/web/2.x.x/_common/clientSessionCachingEnabled.mdx";
import ClientSessionLifecycleCallbacks from "../../../../content/sdk/web/2.x.x/_common/clientSessionLifecycleCallbacks.mdx";
import OnBeforePaymentCreate from "../../../../content/sdk/web/2.x.x/_common/onBeforePaymentCreate.mdx";
import VaultOptions from "../../../../content/sdk/web/2.x.x/primer/_showUniversalCheckout/vaultOptions.mdx";
import OnCheckoutComplete from "../../../../content/sdk/web/2.x.x/_common/onCheckoutComplete.mdx";
import OnCheckoutFail from "../../../../content/sdk/web/2.x.x/_common/onCheckoutFail.mdx";
import ManualPaymentHandling from "../../../../content/sdk/web/2.x.x/_common/manualPaymentHandling.mdx";
import OnPaymentMethodAction from "../../../../content/sdk/web/2.x.x/_common/onPaymentMethodAction.mdx";
import ApiVersion from "../../../../content/sdk/web/2.x.x/_common/apiVersion.mdx";
import * as React from 'react';
export default {
  CustomizationStyle,
  Form,
  SubmitButton,
  ProcessingIndicator,
  ErrorMessage,
  SuccessScreen,
  PaymentMethodsOptions,
  ClientSessionCachingEnabled,
  ClientSessionLifecycleCallbacks,
  OnBeforePaymentCreate,
  VaultOptions,
  OnCheckoutComplete,
  OnCheckoutFail,
  ManualPaymentHandling,
  OnPaymentMethodAction,
  ApiVersion,
  React
};